<template>
  <div class="table">
      <el-table
        ref="multipleTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="order_code" label="订单号"></el-table-column>
         <el-table-column prop="goods_name" label="商品名称" ></el-table-column>    
        <el-table-column prop="goods_num" label="商品数量" ></el-table-column>
        <el-table-column prop="goods_price" label="商品金额">
           <template slot-scope="scope">
              ￥{{scope.row.goods_price}}
           </template>
          </el-table-column> 
        <el-table-column prop="return_price" label="退款金额">
            <template slot-scope="scope">
              ￥{{scope.row.return_price}}
           </template></el-table-column> 
        <el-table-column prop="code" label="售后单号"></el-table-column>
        <el-table-column prop="status" label="售后状态"  >
           <template slot-scope="scope">
              <span v-show = "scope.row.status == 1">待审核</span>
              <span v-show = "scope.row.status == 5">待复核</span>
              <span v-show = "scope.row.status == 10">复核中</span>
              <span v-show = "scope.row.status == 15">复核通过</span>
              <span v-show = "scope.row.status == 20">已完结</span>
              <span v-show = "scope.row.status == 25">审核拒绝</span>
              <span v-show = "scope.row.status == 30">复核拒绝</span>
              <span v-show = "scope.row.status == 35">售后取消</span>
           </template>
        </el-table-column>
        <el-table-column prop="verify_remark" label="审核备注"> </el-table-column>
        <el-table-column prop="11" label="操作" >
          <template slot-scope="scope">
           <button
            class="cancel-btn"
            v-if="scope.row.status == 1"
            @click="removeItem(scope.row.code)"
          >
            取消
          </button>
          <button
            class="cancel-btn"
            v-if="scope.row.status == 20"
            @click="rebuy(scope.row.sku)"
          >
            再次购买
          </button>
          </template>
        
        </el-table-column>
        <div slot="empty" style="height: 300px; line-height: 250px">
            暂无数据
        </div>
      </el-table>
  </div>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {
      dialogVisible: false,
      detailList: {
        data: {
          item: []
        }
      }
    };
  },
  methods: {
    removeItem(code){
        this.$api.order.recanceld({
          code:code
        }).then(res=>{
          if(res.status == 1){
             this.$message({
                type: 'success',
                message: '取消售后成功'
              });
              this.$router.push('/personalCenter/orderCenter')
          }else{
            this.$message({
                type: 'error',
                message: res.msg
              });
          }
        })
    },
    rebuy(id){
      let routeUrl = this.$router.resolve({
        path: `/homepage/detail`,
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table {
  width: 100%;
  .el-table__header-wrapper table,
  .el-table__body-wrapper table {
    width: 100% !important;
  }
  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto;
  }
}
/deep/.el-table th,
.el-table tr {
  background: #eee;
  color: #515a6e;
}
/deep/.el-table {
  padding: 20px;
}
.cancel-btn{
  background:#1890ff;
  color:#fff;
  border-radius: 3px;
  height:26px;
  min-width:50px;
  line-height:26px;
  text-align:center;
  padding:0px 10px;
  font-size:12px;
  margin-left:10px;
  cursor: pointer;
  border:0;
}
</style>
